import { useEffect, useState } from "react";
import { loadModules } from "esri-loader";
import LoadingOverlay from "./LoadingOverlay/LoadingOverlay";

const URLServDivPol =
    process.env.REACT_APP_HERMES2_URL +
    process.env.REACT_APP_DIVISION_POLITICA_URL;

const SelectDepto = ({ selectedDepto, setSelectedDepto, setSelectedMpio }) => {
    const [deptos, setDeptos] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        loadModules(["esri/tasks/query", "esri/tasks/QueryTask"]).then(
            ([Query, QueryTask]) => {
                const queryTask = new QueryTask(URLServDivPol + "4");
                const query = new Query();
                query.where = "1=1";
                query.orderByFields = ["departamento"];
                query.returnGeometry = false;
                query.outFields = ["departamento", "codigodepartamento"];
                queryTask.execute(query).then((results) => {
                    const filtered = results.features
                        .map((f) => f.attributes)
                        .filter((d) => d.departamento !== "BOGOTÁ");
                    setDeptos(filtered);
                    setLoading(false);
                });
            }
        );
    }, []);

    const handleChange = (e) => {
        const value = e.target.value;
        setSelectedDepto(value);
        setSelectedMpio("-1");
    };

    return (
        <div className="col-12 col-md-3">
            {loading && (
                <LoadingOverlay mensaje="Consultando departamento..." />
            )}
            <h3 className="titles-form font-mpb">Departamento:</h3>
            <div className="caja">
                <select
                    id="deptos"
                    className="form-select"
                    value={selectedDepto}
                    onChange={handleChange}
                >
                    <option value="-1">Seleccione un Departamento</option>
                    {deptos.map((d) => (
                        <option
                            key={d.codigodepartamento}
                            value={d.codigodepartamento}
                        >
                            {d.departamento}
                        </option>
                    ))}
                </select>
            </div>
        </div>
    );
};

export default SelectDepto;
